import axios from '@fs/zion-axios'

const BASE_TREE_GRAPH_PATH = '/service/dmc/tree-graph'

export default () => {}

export function resyncTreeGraph(personId) {
  return axios.get(`${BASE_TREE_GRAPH_PATH}/${personId}/sync`)
}
